import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function Picks() {
  const picks = comics.filter((c) => c.recommend);
  const [feature, ...rest] = picks;

  return (
    <section className="bg-background-100 border-y border-background-200/60">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500/15 px-3 py-1 text-xs font-semibold text-accent-600">
              <i className="ri-star-smile-fill"></i> 主笔精选
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl text-foreground-950">编辑精选</h2>
            <p className="mt-2 text-sm text-foreground-500">主笔团队亲自把关的年度口碑之作</p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {/* feature large card */}
          <Link
            to={`/comic/${feature.id}`}
            className="group relative overflow-hidden rounded-2xl md:col-span-2 lg:col-span-2 md:row-span-2 min-h-[340px]"
          >
            <img
              src={feature.banner}
              alt={`${feature.title} 精选封面`}
              title={feature.title}
              loading="lazy"
              className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent"></div>
            <div className="absolute inset-x-0 bottom-0 p-6">
              <span className="inline-flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-[10px] font-bold text-background-50 whitespace-nowrap">
                <i className="ri-star-fill text-xs"></i> 主笔强推
              </span>
              <h3 className="mt-3 font-heading text-2xl text-foreground-950">{feature.title}</h3>
              <p className="mt-2 line-clamp-2 text-sm leading-6 text-foreground-800">{feature.description}</p>
              <div className="mt-3 flex flex-wrap items-center gap-2">
                {feature.tags.map((t) => (
                  <span key={t} className="rounded-md bg-white/15 px-2 py-0.5 text-xs text-foreground-950 whitespace-nowrap">
                    {t}
                  </span>
                ))}
              </div>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-primary-500">
                立即阅读 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </span>
            </div>
          </Link>

          {rest.map((c) => (
            <Link
              key={c.id}
              to={`/comic/${c.id}`}
              className="group relative overflow-hidden rounded-2xl min-h-[190px]"
            >
              <img
                src={c.banner}
                alt={`${c.title} 精选封面`}
                title={c.title}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-5">
                <span className="flex items-center gap-1 text-xs text-accent-500">
                  <i className="ri-star-fill"></i> {c.rating}
                </span>
                <h3 className="mt-1 truncate font-heading text-lg text-foreground-950">{c.title}</h3>
                <p className="mt-1 text-xs text-foreground-700">{c.status} · {c.views}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}